import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAccount } from '../contexts/AccountContext';
import { firstAccessiblePath, type ExtranetPermission } from '../domain/access';

interface RequirePermissionProps {
  permission: ExtranetPermission;
  children: ReactNode;
}

/**
 * Garde de route par permission (`/me.permissions`). Sans la permission, on
 * renvoie vers la première page ouverte à l'appelant — jamais vers une page
 * interdite, donc pas de boucle de redirection.
 */
export const RequirePermission = ({ permission, children }: RequirePermissionProps) => {
  const { can, permissions } = useAccount();
  if (!can(permission)) return <Navigate to={firstAccessiblePath(permissions) ?? '/'} replace />;
  return <>{children}</>;
};
